import gql from 'graphql-tag';

export const GET_EVENT_MASTERS = gql`
  query EventsMasters($filter: EventsMastersInput) {
    eventsMasters(filter: $filter) {
      id
      name
    }
  }
`;
